<template>
  <div>
    <a-card :title="$t('new_meeting')" :bordered="false" style="width: auto">
      <a-form :form="form" :label-col="labelCol" :wrapper-col="wrapperCol" @submit="handleSubmit">
        
        <a-form-item label="Name:"  >
          <a-input
            v-decorator="[
              'meeting_name',
              { rules: [{ required: true, message: 'Enter meeting name!' }] },
            ]"
            placeholder="Meeting name"
        />
        </a-form-item>
        <a-form-item label="Type" >
          <a-select
            v-decorator="[
              'meeting_type',
              { rules: [{ required: true, message: 'Please select meeting type!' }] },
            ]"
            placeholder="Please select a type"
            @change="ChangeMeetingType"
          >
            <a-select-option value="1">
              Instant Meeting
            </a-select-option>
            <a-select-option value="2">
              Scheduled Meeting
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Data" style="width: 100%" v-if="show_date_time">
          <a-date-picker v-decorator="['date-picker', config]" @change="onSelect"></a-date-picker>
        </a-form-item>

        <a-form-item label="Time" v-if="show_date_time">
            <a-select
              v-decorator="[
                'meeting_time',
                { rules: [{ required: true, message: 'Time is required!' }] },
              ]"
              style="width: 100%"
            >
              <a-select-option v-for="item in free_times" :key="item" :disabled="!item.valid" :value="item.time">{{item.time}}</a-select-option>
            </a-select>
        </a-form-item>

        <a-form-item label="Duration" v-if="show_date_time">
          <a-input-number  
            :min="15" 
            :max="1000" 
            style="width: 100%"
            v-decorator="[
              'duration',
              { initialValue:  '30',rules: [{ required: true, message: 'Duration is required!' }] },
            ]"
          />
        </a-form-item>
          <hr>
           <a-form-item class="pull-right">
            <a-button type="primary" html-type="submit" class="login-form-button">
              {{$t('add_meeting')}}
            </a-button>
          </a-form-item>

      </a-form>
    </a-card>
  </div>
</template>

<script>
import API from '../services/api.js';
import moment from 'moment'
export default {
  data(){
    return {
      show_date_time:true,
      config: {
        rules: [{ type: 'object', required: true, message: 'Please select date!' }],
      },
      config_time: {
        rules: [{ type: 'object', required: true, message: 'Please select time!' }],
      },
      configMinutes:{ initialValue: 15,
        rules: [{ required: false, message: '' }],
      },
      minutes:['15','30','45'],
      datasot: moment(new Date()).format('YYYY-MM-DD'),
      value: moment(new Date()).format('YYYY-MM-DD'),
      selectedValue: moment(new Date()),
      meetingstoday:[],
      free_times:[],
      number: 0,
      test:'disabled',
      maximum:0,
      labelCol: {
        xs: { span: 18 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 15 },
      },
    }
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'normal_form' });
  },
  created(){
    //this.test();
  },
  computed: {
    userLogin() {
      return this.$store.state.auth.user;
    },
    enabledHours(){
      return this.hours_test.filter(item => item.enabled === true)
    },
    formItemLayout() {
      const { formLayout } = this;
      return formLayout === 'horizontal'
        ? {
            labelCol: { span: 6 },
            wrapperCol: { span: 16 },
          }
        : {};
    },
  },
  methods: {
    moment,
    getDisabledHours(){
      var hours = [];
      for(var i =0; i < moment().hour(); i++){
        if(i< 9)
          hours.push(i);
      }
      return ['01','02','03'];

    },
    ChangeMeetingType(value){
      console.log(value)
      if(value != 2){
        this.show_date_time = false;
      }else{
         this.show_date_time = true;
      }
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields(async (err, values) => {
        if (!err) {
        
          
          if(values.minutes == 0){
             return;
          }
          if(values.meeting_type == 'Instant Meeting'){
            values.meeting_type = 1
          }
          if(values.meeting_type == 'Scheduled Meeting'){
            values.meeting_type = 2
          }
          
          values.meeting_type = parseInt(values.meeting_type)
          const fixed_values = {
            ...values,
            date: values['date-picker'].format('YYYY-MM-DD'),
          };

          await API.post(`/user/${this.userLogin.email}/meetings`,fixed_values)
          .then(response => {
            if(response.status === 200){
              this.openNotification('Sukses','Takimi u ruajt!')
              this.$store.dispatch('getMeetings');
              this.form.setFieldsValue({
                meeting_name:'',
                meeting_type:'',
                meeting_time:'',
                duration:'',
                date:'',
                'date-picker':''
              });
            }
            if(response.status === 202){
              alert(response.data.error)
            }
          })         
        }
      });
      
    },
    getMeetings(){
        this.$parent.getMeetings()
    },
    openNotification(message,description) {
      this.$notification.open({
        message: message,
        description: description,
      });
    },
    async onSelect(date, dateString) {
      let formatedselected = moment(date).format('YYYY-MM-DD');
      this.value = formatedselected
      this.selectedValue = dateString
      if(this.datasot > formatedselected){
        //return;
      }
      await API.post(`/user/${this.userLogin.userid}/freehours`,{dateString})
          .then(response => {
            if(response.status === 200){
              this.free_times = response.data;
            }
            if(response.status === 202){
              alert(response.data.error)
            }
          })
    },
    onchangeHour(value){
      if(value > 0)   this.minutes = ['0','15','30','45']
      if(value === 0) {
        this.number = 15
        this.minutes = ['15','30','45']
      }
    },
    timeSelect(value){
    
      this.hours_test.map((item,index) => {
        
        if(item.time == value && item.enabled == true){
            
            let next_meeting = this.hours_test[index + 1];
            if(next_meeting.enabled == false){
              let start = moment(`${this.value} ${value}`)
              let end = moment(`${this.value} ${next_meeting.time}`)
              let duration = moment.duration(end.diff(start));
              let minutes = duration.asMinutes();
              this.maximum = minutes           
            }
            console.log(next_meeting)
        }
      })
    }
  },
};
</script>
<style>

</style>